// extracted by mini-css-extract-plugin
export var aircallIframe = "_m5-3";
export var fabContainer = "_m5-5";
export var fabRinging = "_m5-6";
export var loadingOverlay = "_m5-4";
export var pulse = "_m5-7";
export var widgetContent = "_m5-2";
export var widgetPanel = "_m5-0";
export var widgetPanelExpanded = "_m5-1";